<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center justify-content-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium disabled" :to="{name : 'account_prefrences',params:{'id':$route.params.id}}"> <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('add_fund.text1')}} </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('add_fund.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('add_fund.text3')}} <span class="bgTitle">{{$t('add_fund.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12">
                <div class="border text-center p-md-4 p-2 br-10">
                    <h2 class="mb-4 medium">{{$t('add_fund.text5')}}</h2>
                    <div class="text-center">
                        <img width="480" :src="`${static_vars.imagePath}/assets/images/updatedSoon.gif`" :alt="$t('add_fund.text9')" :title="$t('add_fund.text9')" />
                        <h4 class="my-4 semibold">{{$t('add_fund.text6')}}</h4>
                        <div class="d-flex align-items-center justify-content-center pt-3 my-4">
                            <a href="javascript:void(0)" type="submit" class="me-3 min-200 grd_btn py-2 border-button" @click="redirect()">{{$t('add_fund.text7')}}</a>
                            <a href="javascript:void(0)" type="submit" class="grd_btn py-2 min-200" @click="getFundsToken()">{{$t('add_fund.text8')}}</a>
                            <!-- <p>Or</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { useMainStore } from "@/store";
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        data() {
            return {};
        },
        methods: {
            redirect(){
                if(this.store.userAccoutDetail.requiredActions && this.store.userAccoutDetail.requiredActions.length){
                    this.$router.replace({path : '/sutaibility'})
                }else{
                    let path = `${this.static_vars.domainURL}dashboard`
                    window.location.replace(path)
                }
            },
            getFundsToken() {
                this.store.getFundToken({}, true, this.$route.params.id).then((response) => {
                    if (Object.keys(this.store.brokerSettingsList).length && this.store.brokerSettingsList.FUND_URL) {
                        let link = this.store.brokerSettingsList.FUND_URL + "?auth=" + response;
                        window.open(link, "_blank");
                    }
                });
            },
        },
        created() {
            if(Object.keys(this.store.brokerStatusList).length){
                if('currentStep' in this.store.brokerStatusList && parseInt(this.store.brokerStatusList.currentStep) != 8){
                    this.getFundsToken();
                }
            }
        },
    };
</script>
